import React, { useState, useRef, useEffect } from "react";
import "remixicon/fonts/remixicon.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [open]);


  return (
    <div
      className="fixed top-0 w-full z-50 
                 flex items-center justify-between
                 px-4 md:px-10 py-4 
                 text-blue-900 bg-transparent"
    >
      {/* Left Logo */}
      <div className="text-4xl md:text-5xl font-[anzo] cursor-pointer">
        <h1 className="text-blue-300">
          Akshita Laddha
        </h1>
      </div>

      {/* Right section */}
      <div className="flex items-center gap-3 md:gap-4">
        <a
          href="#HireMe"
          className="bg-blue-300
                     text-2xl md:text-4xl
                     px-3 md:px-4
                     py-1 md:py-0
                     rounded-full
                     font-[anzo]
                     hover:bg-blue-200
                     transition"
        >
          Hire me
        </a>

        <i
          className="ri-menu-3-line
                    text-2xl md:text-3xl
                    cursor-pointer
                    hover:text-blue-300"
          onClick={(e) => {
            e.stopPropagation();   // prevents outside click trigger
            setOpen(prev => !prev);
          }}
        />


      </div>

      {/* Dropdown */}
      {open && (
        <div
          ref={menuRef}
          onClick={(e) => e.stopPropagation()}
          className="absolute top-16 right-4 md:right-10
                    w-[90vw] md:w-56
                    bg-blue-300 shadow-2xl rounded-2xl
                    p-5 md:p-6 flex flex-col
                    gap-3 md:gap-4 text-3xl md:text-5xl font-[anzo]"
        >

          <a href="#Page1" className="hover:text-blue-500 transition">
            Home
          </a>
          <a href="#Page4" className="hover:text-blue-500 transition">
            Projects
          </a>
          <a href="#Page6" className="hover:text-blue-500 transition">
            Service
          </a>
          <a href="#Page3" className="hover:text-blue-500 transition">
            About
          </a>
          <a href="#Page5" className="hover:text-blue-500 transition">
            Tools
          </a>
        </div>
      )}
    </div>
  );
};

export default Header;
